export class PriceListProduct {
    constructor(
        public name: string,
        public price: number,
        public global: boolean,
        public id?: string,
    ) {}

    getData() {
        return { ...this };
    }

    static fromData(data: Omit<ReturnType<PriceListProduct['getData']>, 'getData'>) {
        return new this(data.name, data.price, data.global, data.id);
    }
}
